import * as React from "react";
import { css } from "@emotion/react";
import { Icon } from "main/javascripts/components/icon/Icon";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  backgroundColor,
  hex2rgba,
  shadeColorLog,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import { borderRadius } from "main/javascripts/styles/base/borderStyle";

export interface IProps {
  noticeMessages: string[];
  hideIcon?: boolean;
}

export const FormNoticesBlock: React.FC<IProps> = (
  props: IProps
): React.ReactElement | null => {
  const { noticeMessages, hideIcon } = props;

  if (!noticeMessages || noticeMessages.length === 0) {
    return null;
  }

  const blockStyles = hideIcon
    ? [blockStyle, blovkWithoutIconStyle]
    : blockStyle;

  return (
    <div css={blockStyles}>
      {!hideIcon && (
        <div css={iconStyle}>
          <Icon styleKey="info" />
        </div>
      )}
      <div css={noticeListStyle}>
        {(noticeMessages || []).map((noticeMessage: string): JSX.Element => {
          return <div key={noticeMessage}>{noticeMessage}</div>;
        })}
      </div>
    </div>
  );
};

const blockStyle = css`
  padding: ${space.atom1_5x} ${space.atom2x} ${space.atom1_5x} 2.5rem;
  box-sizing: border-box;
  position: relative;
  background: ${shadeColorLog(
    hex2rgba(backgroundColor.primaryLightColor),
    -0.125
  )};
  border-radius: ${borderRadius.normal};
  margin: ${space.atom} ${space.atom} ${space.atom};
`;
const blovkWithoutIconStyle = css`
  padding-left: ${space.atom2x};
`;
const noticeListStyle = css`
  display: grid;
  gap: ${space.atom0_5x};
  color: ${textColor.primaryDarkColor};
  font-size: ${fontSize.caption};
  line-height: ${lineHeight.caption3};
  font-weight: ${fontWeight.medium};
`;
const iconStyle = css`
  position: absolute;
  top: ${space.atom};
  left: ${space.atom};
  display: block;
  font-size: 1.5rem;
  color: ${textColor.primaryDarkColor};
  text-align: center;
  box-sizing: border-box;
`;
